module.exports = __webpack_public_path__ + "img/67425c6.jpg";